import React, { useState, useEffect } from "react";

import { ReviewData } from "types";

import {
  REVIEW_TITLE,
  REVIEW_DESCRIPTION,
  SUBMIT_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
  CANCEL_BUTTON_TEXT,
} from "pages/WorkersCompApplcation/utils/contants";
import FooterButton from "uicomponents/FooterButton";

import BusinessDetailsReview from "./components/BusinessDetailsReview";
import OfficeLocationReview from "./components/OfficeLocationReview";
import OwnersAndEmployeesReview from "./components/OwnersAndEmployeesReview";
import EmployeesAttributesReview from "./components/EmployeesAttributesReview";
import AboutYourBusinessReview from "./components/AboutYourBusinessReview";
import BusinessAttributesReview from "./components/BusinessAttributesReview";
import DocumentsReview from "./components/DocumentsReview";
import EPLIReview from "./components/EPLIReview";

import styles from "./ReviewAndSubmit.module.css";
import { CheckboxInput } from "@justworkshr/milo-components";
import { trackPageViewUserStep } from "utils/analytics/trackEvent";
import { hasQueryParam } from "utils/helper";
export interface IReviewSectionType {
  title: string;
  questions: { [key: string]: string };
}

interface IReviewAndSubmitPageProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
  setActiveStepIndex: (index: number) => void;
  data: ReviewData;
}

const ReviewAndSubmitPage = ({
  data,
  setPreviousStep,
  setNextStep,
  setActiveStepIndex,
}: IReviewAndSubmitPageProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(10, "review");
  }, []);
  const [checkboxStatus, setCheckboxStatus] = useState<boolean>(false);
  const [isLoadingSteps, setIsLoadingSteps] = useState(false);

  const handleBack = (): void => {
    setPreviousStep();
  };

  const handleSubmit = (): void => {
    setIsLoadingSteps(true);
    setNextStep();
  };

  const reviewsListWithoutCoreApp = [
    <BusinessDetailsReview
      data={data}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={0}
    />,
    <OfficeLocationReview
      data={data?.officeLocations}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={1}
    />,
    <OwnersAndEmployeesReview
      data={data?.employeeCensuses}
      officeLocations={data?.officeLocations}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={2}
    />,
    <EmployeesAttributesReview
      data={data?.companyInformation}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={3}
      employeeCensus={data?.employeeCensuses}
    />,
    <AboutYourBusinessReview
      data={data}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={4}
    />,
    <BusinessAttributesReview
      data={data}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={5}
    />,
    <DocumentsReview
      data={data?.companyInformation}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={6}
    />,
    <EPLIReview
      data={data}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={7}
    />,
  ];

  const reviewsListWithCoreApp = [
    <BusinessDetailsReview
      data={data}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={0}
    />,
    <OwnersAndEmployeesReview
      data={data?.employeeCensuses}
      officeLocations={data?.officeLocations}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={1}
    />,
    <EmployeesAttributesReview
      data={data?.companyInformation}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={2}
      employeeCensus={data?.employeeCensuses}
    />,
    <AboutYourBusinessReview
      data={data}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={3}
    />,
    <BusinessAttributesReview
      data={data}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={4}
    />,
    <DocumentsReview
      data={data?.companyInformation}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={5}
    />,
    <EPLIReview
      data={data}
      documents={data?.applications?.[0]?.documents}
      setActiveStepIndex={setActiveStepIndex}
      sectionNumber={6}
    />,
  ];

  const reviewsList = hasQueryParam("usecoreapp")
    ? reviewsListWithCoreApp
    : reviewsListWithoutCoreApp;

  return (
    <div className={styles.container}>
      <div className={styles.title}>{REVIEW_TITLE}</div>

      <div className={styles.description}>{REVIEW_DESCRIPTION}</div>

      <div className={styles.sectionsContainer}>
        {reviewsList.map((review, index) => (
          <React.Fragment key={index}>{review}</React.Fragment>
        ))}
      </div>

      <div className={styles.checkboxContainer}>
        <CheckboxInput
          name="terms"
          defaultChecked={false}
          value="Y"
          label="I am an authorized representative of the business listed above and hereby attest that this information is accurate and complete."
          onChange={(e) => setCheckboxStatus(e.target.checked)}
        />
      </div>

      <FooterButton
        nextButtonText={
          isLoadingSteps ? LOADING_BUTTON_TEXT : SUBMIT_BUTTON_TEXT
        }
        backButtonText={CANCEL_BUTTON_TEXT}
        disabled={!checkboxStatus || isLoadingSteps}
        buttonType="button"
        handleNextClick={handleSubmit}
        handleBackClick={handleBack}
      />
    </div>
  );
};

export default ReviewAndSubmitPage;
